import React, { useState, useEffect } from 'react'
import { Header } from 'semantic-ui-react'
import { useFormatMessage } from '../../utils/intlHelpers'
import { connect } from 'react-redux'
import { ApexAccounts } from 'apex-ui-services'
import { ApexApiError } from '@Types'
import { RootState } from '../../store'
import { MessageCenter } from '../../components/MessageCenter'
import styles from './styles.module.less'
import { Text } from '@chakra-ui/react'

export interface Props {
  noResults: boolean
  error?: ApexApiError | null
}

const CashTransfersHomeComponent = ({ noResults, error }: Props) => {
  const formatMessage = useFormatMessage()
  const [text, setText] = useState({
    title: formatMessage('cashTransfers.title'),
    message: formatMessage('cashTransfers.helpText')
  })
  const [errorMessages, setErrorMessages] = useState<string[]>([])
  const [infoMessages, setInfoMessages] = useState<string[]>([])

  useEffect(() => {
    if (error) {
      setText({
        title: formatMessage('cashTransfers.searchResultsError'),
        message: ''
      })
      if (error?.body?.errorCode && error?.body?.errorDescription) {
        setErrorMessages([`${error?.body?.errorCode}: ${error?.body?.errorDescription}`])
      }
    } else if (noResults) {
      setText({
        title: formatMessage('cashTransfers.searchResults'),
        message: ''
      })
      setInfoMessages([formatMessage('cashTransfers.noSearchResults')])
    }
    // eslint-disable-next-line
  }, [noResults, error])

  return (
    <>
      <Header as='h1' className={styles.homeHeader}>
        {text.title}
      </Header>
      {text.message && (
        <Text textStyle='lead' data-testid='cash-transfers-message' className={`${styles.homeSubheader}`}>
          {text.message}
        </Text>
      )}
      <MessageCenter errorMessages={errorMessages} infoMessages={infoMessages} dismissable={false} compact={true} />
    </>
  )
}

const mapStateToProps = (state: RootState) => ({
  noResults: ApexAccounts.accounts.selectors.noResults(state),
  error: ApexAccounts.accounts.selectors.error(state)
})

export const CashTransfersHome = connect(mapStateToProps)(CashTransfersHomeComponent)
